import React from "react";
import Box from "@mui/material/Box";
import {
  Backdrop,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import LockIcon from "@mui/icons-material/Lock";
import { loginAction } from "../Store/LoginAuth";
import { MobileLoginAction } from "../Store/MobileLogin";
import Button from "@mui/material/Button";
import "./Idlogin.css";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Alert from "@mui/material/Alert";
import { BranchAction } from "../Store/Branch";
import CryptoJS from "crypto-js";
import Snackbar from "@mui/material/Snackbar";

const Idlogin = () => {
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const { vertical, horizontal, open } = state;
  const [alert, setAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  const employeeOnClickHandler = () => {
    closeAlertHandler();
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateToMobileNumberLogin = () => {
    dispatch(loginAction.updateLogin(false));
    dispatch(loginAction.updateEmployeeIDScreen(false));
    dispatch(loginAction.updateMobileScreen(true));
    dispatch(MobileLoginAction.updateNumberSection(true));
    dispatch(MobileLoginAction.updateOTPSection(false));
  };
  const [employeeID, setEmployeeId] = useState("");
  const [password, setPassword] = useState("");
  const [employeeIdIsTouched, setEmployeeIdIsTouched] = useState(false);
  const [passwordIsTouched, setPasswordIsTouched] = useState(false);
  const nameValid = employeeID.trim() !== "";
  const passwordValid = password.trim() !== "";
  const nameHasError = employeeIdIsTouched && !nameValid;
  const passwordHasError = passwordIsTouched && !passwordValid;
  const onChangeEmployeeID = (event) => {
    setEmployeeId(event.target.value.toUpperCase());
  };
  const onChangePassword = (event) => {
    setPassword(event.target.value);
  };

  const SendData = async () => {
    setLoading(true);
    try {
      const loginResponse = await axios.post("/api/validateLogin", {
        apiCode: "LOGIN_DTLS_API",
        createdBy: employeeID,
        requestBody: {
          user_id: btoa(employeeID),
          password: btoa(password),
        },
      });
      if (loginResponse.data.message === "Success") {
        dispatch(BranchAction.updateUserName(employeeID.toUpperCase()));
        dispatch(BranchAction.updateUserID(loginResponse.data.user_id));
        const randomKey = (Math.random() + 1).toString(36).substring(7);
        sessionStorage.setItem("randomKey", btoa(randomKey));
        const data = CryptoJS.AES.encrypt(
          JSON.stringify(true),
          randomKey
        ).toString();
        sessionStorage.setItem("ConfigDt", data);
        // dispatch(BranchAction.updateLoginStatus(true));
        dispatch(loginAction.updateEmployeeIDScreen(false));
        dispatch(loginAction.updateLogin(true));
        setLoading(false);
        navigate("/stlap/home/dashboard", { replace: true });
      }

      if (loginResponse.data.message === "Failure") {
        setTimeout(() => {
          setLoading(false);
          setErrorMessage(loginResponse.data.error_msg);
          openAlertHandler();
        }, 2000);
      }
    } catch (e) {
      setTimeout(() => {
        setLoading(false);
        console.log(e);
        if (e.code === "ERR_NETWORK") {
          setErrorMessage(e.message);
        }
        openAlertHandler();
      }, 2000);
    }
  };
  const loginHandler = () => {
    setEmployeeIdIsTouched(true);
    setPasswordIsTouched(true);
    if (nameValid && passwordValid) {
      SendData();
    }
  };
  const employeeBlurHandler = () => {
    setEmployeeIdIsTouched(true);
  };
  const passwordBlurHandler = () => {
    setPasswordIsTouched(true);
  };
  // Enter key Handler
  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      loginHandler();
    }
  };
  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      )}
      <Box
        sx={{
          backgroundColor: "white",
          padding: "1rem",
          boxShadow: "0 2px 5px 0 rgb(113 113 113 / 24%)",
          borderRadius: "1.4rem",
          height: "23rem",
          position: "relative",
        }}
      >
        <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
          <LockIcon sx={{ color: "#004a92" }} />
          <Typography variant="body" sx={{ color: "#004a92", fontWeight: 700 }}>
            LMS Login
          </Typography>
        </Box>
        <Box sx={{ marginTop: "1.5rem" }}>
          <RadioGroup row defaultValue="internal">
            <FormControlLabel
              value="internal"
              control={<Radio />}
              label="Internal"
            />
            <FormControlLabel
              value="external"
              disabled
              control={<Radio />}
              label="External"
            />
          </RadioGroup>
        </Box>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={1} sx={{ alignItems: "center" }}>
              <Grid item xs={12}>
                <InputLabel
                  sx={{ color: "#004a92", fontWeight: 550, fontSize: "14px" }}
                >
                  User ID
                </InputLabel>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  onClick={employeeOnClickHandler}
                  onKeyDown={handleKeypress}
                  placeholder="Enter Employee ID"
                  error={nameHasError ? true : false}
                  value={employeeID}
                  autoFocus
                  onBlur={employeeBlurHandler}
                  onChange={onChangeEmployeeID}
                  sx={{
                    boxShadow: "0 2px 5px 0 rgb(113 113 113 / 24%)",
                    border: "none",
                  }}
                  size="small"
                />
                {nameHasError && (
                  <p className="error">Please Enter Employee ID</p>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "1.4rem" }}>
            <Grid container spacing={1} sx={{ alignItems: "center" }}>
              <Grid item xs={12}>
                <InputLabel
                  sx={{ color: "#004a92", fontWeight: 550, fontSize: "14px" }}
                >
                  Password
                </InputLabel>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  type="password"
                  placeholder="Enter Password"
                  error={passwordHasError ? true : false}
                  value={password}
                  onKeyDown={handleKeypress}
                  onBlur={passwordBlurHandler}
                  onChange={onChangePassword}
                  sx={{
                    boxShadow: "0 2px 5px 0 rgb(113 113 113 / 24%)",
                    border: "none",
                  }}
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                />
                {passwordHasError && (
                  <p className="error">Please Enter Password </p>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box
          sx={{
            marginTop: "2rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={loginHandler}
            variant="contained"
            sx={{ backgroundColor: "#004a92" }}
          >
            Login
          </Button>
        </Box>
        {/* <Box className="login-info" sx={{ marginTop: "2rem" }}>
        <Link
          onClick={navigateToMobileNumberLogin}
          underline="none"
          sx={{
            cursor: "pointer",
            fontSize: "0.9rem",
            color: "#004a92",
            paddingTop: "0.2rem",
            fontWeight: 540,
          }}
        >
          Login with Mobile Number
        </Link>
      </Box> */}
        <Snackbar
          open={alert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical, horizontal }}
          onClose={closeAlertHandler}
        >
          <Alert
            onClose={closeAlertHandler}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errorMessage}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
};

export default Idlogin;
